var _a, _b;
import { AssetType } from "@domains/aggregates/interfaces/Reports/iPNLReport";
export var FilterTabEnum;
(function (FilterTabEnum) {
    FilterTabEnum["ALL"] = "all";
    FilterTabEnum["EQUITY"] = "Equity";
    FilterTabEnum["FI"] = "Fixed Income";
    FilterTabEnum["DERIVATIVE"] = "Derivative";
    FilterTabEnum["MP"] = "Managed Portfolio";
    FilterTabEnum["OTHERS"] = "Other";
})(FilterTabEnum || (FilterTabEnum = {}));
export var EReportsQParamKey;
(function (EReportsQParamKey) {
    EReportsQParamKey["TAB"] = "tab";
    EReportsQParamKey["REPORT_NAME"] = "reportName";
})(EReportsQParamKey || (EReportsQParamKey = {}));
export var EOtherReportTabs;
(function (EOtherReportTabs) {
    EOtherReportTabs["DP_BILL"] = "dpbills";
    EOtherReportTabs["CONTRACT_NOTES"] = "contract-notes";
    EOtherReportTabs["SUBSCRIPTION_HISTORY"] = "subscription-history";
    EOtherReportTabs["DELAYED_PAYMENT_INTEREST"] = "delayed-payment-interest";
    EOtherReportTabs["LEDGER_REPORT"] = "ledger-report";
    EOtherReportTabs["MARGIN_REPORT"] = "margin-report";
})(EOtherReportTabs || (EOtherReportTabs = {}));
export var OtherReport = (_a = {},
    _a[EOtherReportTabs.DP_BILL] = "DP Bills",
    _a[EOtherReportTabs.CONTRACT_NOTES] = "Contract Notes and Statements",
    _a[EOtherReportTabs.DELAYED_PAYMENT_INTEREST] = "Delayed Payment Interest",
    _a[EOtherReportTabs.SUBSCRIPTION_HISTORY] = "Subscription history",
    _a[EOtherReportTabs.LEDGER_REPORT] = "Ledger Report",
    _a[EOtherReportTabs.MARGIN_REPORT] = "Margin Report",
    _a);
export var reportsTabAndDropDownData = (_b = {},
    _b[FilterTabEnum.ALL] = {
        name: "All",
        dropDownList: [],
    },
    _b[FilterTabEnum.EQUITY] = {
        name: FilterTabEnum.EQUITY,
        dropDownList: [
            {
                display: "All",
                value: AssetType.EQ,
            },
            {
                display: "Listed Equity",
                value: AssetType.EQ,
            },
            {
                display: "Unlisted Equity",
                value: AssetType.UnlistedEquity,
            },
        ],
    },
    _b[FilterTabEnum.FI] = {
        name: FilterTabEnum.FI,
        dropDownList: [
            {
                display: "All",
                value: AssetType.FixedIncome,
            },
            {
                display: "Certificate Of Deposit",
                value: AssetType.CertOfDeposit,
            },
            {
                display: "Commercial Paper",
                value: AssetType.CommPaper,
            },
            {
                display: "NCD",
                value: AssetType.NCD,
            },
            {
                display: "Warrant",
                value: AssetType.Warrant,
            },
            {
                display: "Bonds",
                value: AssetType.Bonds,
            },
            {
                display: "Debentures",
                value: AssetType.Debentures,
            },
            {
                display: "Indian Depository Receipt",
                value: AssetType.IndianDepoReceipt,
            },
            {
                display: "Preference Share",
                value: AssetType.PreferenceShare,
            },
            {
                display: "Corp FD",
                value: AssetType.CorpFD,
            },
            {
                display: "RBI Bonds ",
                value: AssetType.RBIBonds,
            },
            {
                display: "54 EC",
                value: AssetType.EC54,
            },
        ],
    },
    _b[FilterTabEnum.DERIVATIVE] = {
        name: FilterTabEnum.DERIVATIVE,
        dropDownList: [
            {
                display: "All",
                value: AssetType.Derivatives,
            },
            {
                display: "Equity",
                value: AssetType.DEquity,
            },
            {
                display: "Currency",
                value: AssetType.DCurrency,
            },
            {
                display: "Commodity",
                value: AssetType.DCommodity,
            },
        ],
    },
    _b[FilterTabEnum.MP] = {
        name: FilterTabEnum.MP,
        dropDownList: [
            {
                display: "All",
                value: AssetType.MP,
            },
            {
                display: "PMS",
                value: AssetType.PMS,
            },
            {
                display: "Mutual Fund",
                value: AssetType.MutualFund,
            },
            {
                display: "ETF",
                value: AssetType.ETF,
            },
            {
                display: "INVITS",
                value: AssetType.INVITS,
            },
            {
                display: "AIF",
                value: AssetType.AIF,
            },
            {
                display: "Structured Products",
                value: AssetType.StructuredProducts,
            },
        ],
    },
    _b[FilterTabEnum.OTHERS] = {
        name: FilterTabEnum.OTHERS,
        dropDownList: [
            {
                display: "All",
                value: [AssetType.RealEstate, AssetType.Commodity],
            },
            {
                display: "Real Estate",
                value: AssetType.RealEstate,
            },
            {
                display: "Commodities",
                value: AssetType.Commodity,
            },
        ],
    },
    _b);
export var initSelectedFilter = {
    simpleFilter: 0,
    assetFilter: 0,
    expiryMonth: 0,
    instrumentType: 0,
    optionType: 0,
    strikePrice: 0,
    underlyingAsset: 0,
};
export var initFilterTray = {
    simpleFilter: true,
    assetFilter: false,
    expiryMonth: false,
    instrumentType: false,
    optionType: false,
    strikePrice: false,
    underlyingAsset: false,
};
export var HoldingEdelweissAssetClass;
(function (HoldingEdelweissAssetClass) {
    HoldingEdelweissAssetClass["EQUITY"] = "Equity Related";
    HoldingEdelweissAssetClass["FI"] = "Fixed Income";
    HoldingEdelweissAssetClass["MP"] = "Managed Portfolios";
    // OTHERS = "Others",
    HoldingEdelweissAssetClass["ALL"] = "ALL";
    HoldingEdelweissAssetClass["RE"] = "Real Estate";
    HoldingEdelweissAssetClass["CO"] = "Commodities";
})(HoldingEdelweissAssetClass || (HoldingEdelweissAssetClass = {}));
